import React, { CSSProperties, FC, useMemo } from 'react';
import "./Button.css"
import Tooltip from "../CustomTooltip/CustomTooltip";

interface IButtonProps {
    id?: string;
    key?: string;
    text?: string;
    image?: string | React.ReactNode;
    tooltip?: boolean;
    title?: string;
    buttonSize?: 'small' | 'medium' | 'large';
    titlePosition?: "top" | "left" | "right" | "bottom";
    style?: CSSProperties;
    className?: string | string[];
    permission?: boolean;
    callBack: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * Компонент для отображения интерактивной кнопки.
 */
const Button: FC<IButtonProps> = ({
    id = "button",
    key = "button",
    text,
    image,
    tooltip,
    title,
    buttonSize = "small",
    titlePosition = "top",
    style,
    className,
    permission = true,
    callBack
}) => {
    const buttonId = useMemo(() =>
        permission ? id : `${id}-gray`,
        [permission, id]);

    const buttonClassName = useMemo(() => {
        const baseClass = "ui__component--button";
        const elemClass = text ? 'ui__component--button-pos-all' : 'ui__component--button-pos-img';
        const sizeClass = `button-size-${buttonSize}`;
        const classes = Array.isArray(className)
            ? className.join(' ')
            : className;
        return `${baseClass} ${elemClass} ${sizeClass} ${classes || ''}`.trim();
    }, [className]);

    const content = useMemo(() => (
        <>
            {image && (
                typeof image === 'string'
                    ? <img src={image} alt={title || text || 'button'} />
                    : image
            )}
            {text && <span>{text}</span>}
        </>
    ), [image, title, text]);

    const buttonProps = {
        id: buttonId,
        key,
        style,
        className: buttonClassName,
        onClick: callBack,
        "aria-label": title || text,
    };

    if (!tooltip) {
        return <button {...buttonProps}>{content}</button>;
    }

    return (
        <button {...buttonProps}>
            <Tooltip
                offset={5}
                text={title || ""}
                placement={titlePosition}
            >
                {content}
            </Tooltip>
        </button>
    );
};

export default React.memo(Button);